import { reactive } from "vue";
import { eventBus } from "@/eventBus";

/* =========================
   🔐 FIX CHECKOUT EXITOSO
========================= */

const checkoutSuccess = sessionStorage.getItem("checkout_success") === "1";

if (checkoutSuccess) {
  localStorage.removeItem("cart");
  sessionStorage.removeItem("checkout_success");
}

const state = reactive({
  cart: JSON.parse(localStorage.getItem("cart")) || []
});

/* =========================
   🔄 UTILIDADES INTERNAS
========================= */

function saveCart() {
  localStorage.setItem("cart", JSON.stringify(state.cart));
  eventBus.cartUpdated++;
}

/* 🔧 Normalizar variantId (FIX REAL) */
function normalizeVariantId(id) {
  if (!id) return null;

  const str = String(id);

  // 🔥 SI YA ES GID → dejarlo igual
  if (str.includes("gid://shopify/ProductVariant/")) {
    return str;
  }

  // 🔥 SI ES NÚMERO → convertir a GID
  const cleanId = str.split("/").pop();
  return `gid://shopify/ProductVariant/${cleanId}`;
}

function findItem(productId, variantId) {

  const normalizedVariant = normalizeVariantId(variantId);

  return state.cart.find(i => {

    const idMatch =
      (i.id === productId || i.product_id === productId);

    const itemVariant = normalizeVariantId(i.variantId);

    /* producto con variante */
    if (normalizedVariant !== null) {
      return idMatch && itemVariant === normalizedVariant;
    }

    /* producto sin variante */
    return idMatch && (itemVariant === null);

  });

}

/* =========================
   🛒 API DEL CARRITO
========================= */

function upsertItem({
  product,
  qty,
  unit,
  variantId,
  variantTitle,
  inventoryItemId,
  variantes
}) {

  const hasVariants =
    (product?.variantes?.length || 0) > 1 ||
    (product?.variants?.length || 0) > 1;

  if (hasVariants && !variantId) {
    variantId =
      product.variantId ||
      product.variants?.[0]?.id ||
      product.variantes?.[0]?.id ||
      null;
  }

  variantId = normalizeVariantId(variantId);

  const price = resolvePrice({
    product,
    unit,
    variantId
  });

  const existing = findItem(
    product.id || product.product_id,
    variantId
  );

  if (existing) {

    existing.qty = qty; // 🔥 FIX CANTIDADES
    existing.unit = unit;
    existing.price = price;
    existing.variantId = variantId;
    existing.inventoryItemId = inventoryItemId;

    if (variantTitle) {
      existing.variantTitle = variantTitle;
    }

  } else {

    state.cart.push({
      ...product,
      qty,
      unit,
      price,
      variantId: variantId ?? null,
      variantTitle: variantTitle || null,
      inventoryItemId,
      variantes: variantes || []
    });

  }

  saveCart();
}

function removeItem(productId, variantId) {

  const normalizedVariant = normalizeVariantId(variantId);

  const index = state.cart.findIndex(i => {

    const idMatch =
      (i.id === productId || i.product_id === productId);

    const itemVariant = normalizeVariantId(i.variantId);

    if (normalizedVariant !== null) {
      return idMatch && itemVariant === normalizedVariant;
    }

    return idMatch && itemVariant === null;

  });

  if (index !== -1) {
    state.cart.splice(index, 1);
    saveCart();
  }

}

function clearCart() {
  state.cart.length = 0;
  saveCart();
}

/* =========================
   📦 EXPORT
========================= */

export function useCart() {
  return {
    cart: state.cart,
    findItem,
    upsertItem,
    removeItem,
    clearCart,
    getDisplayPrice
  };
}

/* =========================
   💲 PRECIOS
========================= */

function resolvePrice({ product, unit, variantId }) {

  if (!product) return "";

  if (variantId && product.variantes?.length) {

    const variant = product.variantes.find(v =>
      normalizeVariantId(v.id) === normalizeVariantId(variantId)
    );

    if (variant) {
      const price = Number(variant.price);
      if (!isNaN(price)) return price;
    }

  }

  if (!product.variantes || product.variantes.length === 0) {
    const price = Number(product.price);
    return isNaN(price) ? "" : price;
  }

  const variants = product.variantes;

  if (unit === "Lb") {
    const lbVar = variants.find(v =>
      v.title?.toLowerCase().includes("lb")
    );
    const price = Number(lbVar?.price);
    if (!isNaN(price)) return price;
  }

  if (unit === "Pz") {
    const pzVar = variants.find(v => {
      const t = v.title?.toLowerCase() || "";
      return t.includes("pz") || t.includes("pieza") || t.includes("piece");
    });

    const price = Number(pzVar?.price);
    if (!isNaN(price)) return price;
  }

  const fallback = Number(product.price);
  return isNaN(fallback) ? "" : fallback;
}

function getDisplayPrice({ product, unit }) {
  if (!product || !unit) return "";
  return resolvePrice({ product, unit });
}